import api from '../services/api';
import { IAccessGroup } from '../shared/interfaces';

interface IResponseGetAccessGroups {
  data: IAccessGroup[];
  count: number;
}
export const getAccessGroups = async (
  take: number,
  skip: number,
  keyword?: string,
): Promise<IResponseGetAccessGroups> => {
  const response = await api.post('/access-groups/list', {
    take,
    skip,
    keyword,
  });
  return response.data;
};

export const postAccessGroup = async (payload: any): Promise<IAccessGroup> => {
  const response = await api.post(`/access-groups`, payload);
  return response.data;
};

export const getSelectAccessGroups = async (
  param: 'all',
): Promise<IAccessGroup[]> => {
  const response = await api.get(`/access-groups/select/${param}`);
  return response.data;
};

export const patchAccessGroup = async (
  id: string | undefined,
  payload: any,
): Promise<IAccessGroup> => {
  if (!id) {
    throw new Error('ID do grupo de acesso não fornecido.');
  }
  const response = await api.patch(`/access-groups/${id}`, payload);
  return response.data;
};
